module.exports = __webpack_public_path__ + "media/images/flags/32/New-Caledonia-b3274f368db1fc94152523b66e573f7f.png";